import {Suspense, useEffect, useState} from "react";
import Button from "./component-assets/Button.jsx";
import ApiRequester from "./ApiRequester.jsx";
import {
    formFail,
    handleSubmitActions,
    formSuccess,
    showModal,
} from "../libs.jsx"
import {toast, ToastContainer} from "react-toastify";
import Header from "./Header.jsx";
import Navigation from "./Navigation.jsx";
import CampusDropDown from "@/components/component-assets/CampusDropDown.jsx";
import { getSession } from "../services/session";

const Shifts = (props) => {
    let dData = getSession();

    // Permission Variables
    const [campusId, setCampusId] = useState(dData.acnt);
    const [shiftData, setShiftData] = useState([]);
    const [shiftLoaded, setShiftLoaded] = useState(false);
    const [count, setCount] = useState(0);
    const [read, setRead] = useState(true);
    const [shiftAssignments, setShiftAssignments] = useState({});
    const [originalShiftAssignments, setOriginalShiftAssignments] = useState({});

    useEffect(() => {
        let interval = null;
        interval = setInterval(() => {
             setCount(count => count - 1);
        }, 1000);
        if (count <= 0){
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt, Tbl: "core_shift_hours",
                                procedure: "fetchbyparameter", reqType: "direct"}).then(data => {
                setShiftData(data ? data : []);
                console.log(data)
                setShiftLoaded(true);
                // Initialize shift assignments from data - ensure all 24 hours have values
                const assignments = {};
                // First, initialize all hours with default "Day" shift
                for (let hour = 0; hour < 24; hour++) {
                    assignments[hour] = {
                        shift_hour_id: null,
                        shift_name: "Day"
                    };
                }
                // Then, override with actual data if available
                if (data && data.length > 0) {
                    data.forEach(item => {
                        if (item.hour_of_day >= 0 && item.hour_of_day < 24) {
                            assignments[item.hour_of_day] = {
                                shift_hour_id: item.shift_hour_id,
                                shift_name: item.shift_name
                            };
                        }
                    });
                }
                setShiftAssignments(assignments);
                // Store original assignments for comparison
                setOriginalShiftAssignments(JSON.parse(JSON.stringify(assignments)));
            });
            setRead(true);
            setCount(count => 600);
        }
        return () => clearInterval(interval);
    }, [count]);

    function createShifts(){
        handleSubmitActions("create-btn", "load-create-btn");
        ApiRequester({reqEndpoint: "mytransaction", TransType: "shift_add", Payload: {},
                            CampusId: dData.acnt, User: dData.user, ClientId: dData.sessionId}).then(data => {
            if (data[0] === true){
                formSuccess(`Shifts have been created.`, "create-btn", "load-create-btn");
                setRead(false);
                setCount(0);
            }
            else{
                formFail(`Error during add, error code: ${data[1]}`, "create-btn", "load-create-btn");
            }
        });
    }

    function editShifts(){
        handleSubmitActions("edit-btn", "load-edit-btn");
        const payload = [];
        for (let hour = 0; hour < 24; hour++) {
            const assignment = shiftAssignments[hour];
            payload.push({
                shift_hour_id: assignment.shift_hour_id,
                shift_name: assignment.shift_name
            });
        }
        ApiRequester({reqEndpoint: "mysave", Tbl: "core_shift_hours", Payload: payload, urlType: "POST",
                            CampusId: dData.acnt, User: dData.user, ClientId: dData.sessionId,
                            PKey: "shift_hour_id", Condition: "primary"}).then(data => {
            if (data[0] === true){
                formSuccess(`Shifts have been updated.`, "edit-btn", "load-edit-btn");
                // Update original assignments to match current state after successful save
                setOriginalShiftAssignments(JSON.parse(JSON.stringify(shiftAssignments)));
                setRead(false);
                setCount(0);
            }
            else{
                formFail(`Error during update, error code: ${data[1]}`, "edit-btn", "load-edit-btn");
            }
        });
    }

    function handleShiftChange(hour, shiftName) {
        setShiftAssignments(prev => {
            const updated = { ...prev };
            if (updated[hour]) {
                updated[hour] = {
                    ...updated[hour],
                    shift_name: shiftName
                };
            } else {
                updated[hour] = {
                    shift_hour_id: null, // Will be created on backend
                    shift_name: shiftName
                };
            }
            return updated;
        });
    }

    function formatHour(hour) {
        const period = hour >= 12 ? 'PM' : 'AM';
        const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
        return `${displayHour}:00 ${period}`;
    }

    function getShiftColor(shiftName) {
        switch(shiftName) {
            case "Day":
                return "#27B4FFFF";
            case "Evening":
                return "#276BFFFF";
            case "Night":
                return "#0B16FFFF";
            default:
                return "#27B4FFFF";
        }
    }

    function hasChanges() {
        // Compare current assignments with original
        for (let hour = 0; hour < 24; hour++) {
            const current = shiftAssignments[hour];
            const original = originalShiftAssignments[hour];
            
            if (!current || !original) {
                return true;
            }
            
            if (current.shift_name !== original.shift_name) {
                return true;
            }
        }
        return false;
    }

    function resetShifts() {
        // Reset shiftAssignments back to original values
        setShiftAssignments(JSON.parse(JSON.stringify(originalShiftAssignments)));
    }

    const headerContent = (
        <div className={"d-flex justify-content-between"}>
            <div>

            </div>
            <CampusDropDown campusId={campusId} setCampusId={(item) => setCampusId(item)}
                            setCount={(item) => setCount(item)} pageAction={(e) => {
                setShiftData([]);
                setShiftLoaded(false);
            }}/>
        </div>
    );

    const footer = (
        <div>
        </div>
    );

    return (
        <>
            <Navigation />
            <div className={"main-content"}>
                <Header preTitle={"Settings"} Title={"Shifts"} content={headerContent} />
                <div className={"container-fluid mt-4"}>
                    {shiftLoaded
                        ?   shiftData.length > 0
                            ?   <div className={"card"}>
                                <div className={"card-header"}>
                                    <h4 className={"mb-0"}>Shift Hour Assignments</h4>
                                    {hasChanges() && (
                                        <div className={"d-flex justify-content-end gap-2"}>
                                            <Button 
                                                text={"Reset"} 
                                                class={"btn btn-secondary"} 
                                                id={"reset-btn"} 
                                                onClick={() => resetShifts()} 
                                            />
                                            <Button 
                                                text={"Save Changes"} 
                                                class={"btn btn-primary"} 
                                                id={"edit-btn"} 
                                                onClick={() => editShifts()} 
                                            />
                                            <Button 
                                                text={"Saving..."} 
                                                class={"btn btn-primary d-none"} 
                                                id={"load-edit-btn"} 
                                                spinner={true} 
                                                disabled={true} 
                                            />
                                        </div>
                                    )}
                                </div>
                                <div className={"card-body"}>
                                    <div className={"row g-3"}>
                                        <p className={"text-muted mb-0"}>Assign each hour of the day to a shift (Day, Evening, or Night).</p>
                                        {Array.from({ length: 24 }, (_, hour) => {
                                            const assignment = shiftAssignments[hour];
                                            const currentShift = assignment ? assignment.shift_name : "Day";
                                            const backgroundColor = getShiftColor(currentShift);
                                            return (
                                                <div key={hour} className={"col-md-6 col-lg-4 col-xl-3"}>
                                                    <div className={"form-floating"}>
                                                        <select 
                                                            className={"form-select"} 
                                                            id={`shift-hour-${hour}`}
                                                            value={currentShift}
                                                            onChange={(e) => handleShiftChange(hour, e.target.value)}
                                                            style={{
                                                                backgroundColor: backgroundColor,
                                                                color: "#FFFFFF",
                                                                borderColor: backgroundColor,
                                                                fontWeight: "500",
                                                                boxShadow: "1px 1px #919191"
                                                            }}
                                                        >
                                                            <option value={"Day"} style={{backgroundColor: "#27B4FFFF", color: "#FFFFFF"}}>Day</option>
                                                            <option value={"Evening"} style={{backgroundColor: "#276BFFFF", color: "#FFFFFF"}}>Evening</option>
                                                            <option value={"Night"} style={{backgroundColor: "#0B16FFFF", color: "#FFFFFF"}}>Night</option>
                                                        </select>
                                                        <label htmlFor={`shift-hour-${hour}`}>
                                                            {formatHour(hour)}
                                                        </label>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                            :   <div>
                                <Button text={"Setup Shifts"} class={"btn btn-primary"} id={"create-btn"} onClick={() => createShifts()} />
                                <Button text={"Creating"} class={"btn btn-primary d-none"} id={"load-create-btn"} spinner={true} disabled={true} />
                            </div>
                        :   <div><span className={"spinner-border spinner-border-sm"} role={"status"} aria-hidden={true} /> Loading</div>
                    }
                    <div className={"footer-spacer"}>

                    </div>
                </div>
                {/*<Footer center={footer}/>*/}
            </div>
            {/* Floating Help Button - Quarter Circle Corner Shape */}
            <button 
                type={"button"} 
                className={"help-corner-button"}
                onClick={() => showModal("helpmodal")}
                title={"Page Help Popup"}
                aria-label={"Open Help"}
            >
                <i className={"fe fe-help-circle help-corner-button-icon"}></i>
            </button>
            <div className={"modal fade help-modal-pop"} id={"helpmodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticHelpBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog modal-lg"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticHelpBackdropLabel"}>Shifts Page Help</h2>
                            <button type={"button"} className={"btn-close"} data-bs-dismiss={"modal"} aria-label={"Close"}/>
                        </div>
                        <div className={"modal-body"}>
                            <div className={"mb-4"}>
                                <h4 className={"text-primary mb-3"}>
                                    <i className={"fe fe-info me-2"}></i>Getting Started
                                </h4>
                                <p className={"mb-2"}>
                                    The Shifts page allows you to configure which hours of the day belong to each shift (Day, Evening, or Night). This configuration is used throughout the system for scheduling, reporting, and shift-based operations.
                                </p>
                            </div>
                            
                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-clock me-2 text-primary"}></i>Understanding Shift Hours
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        <strong>24-Hour Configuration:</strong> Each hour of the day (0:00 to 23:00) must be assigned to one of three shifts: Day, Evening, or Night.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Color Coding:</strong> Each shift has a distinct color to help you quickly identify assignments:
                                        <ul className={"ms-4 mt-2"}>
                                            <li className={"mb-1"}><span style={{color: "#27B4FFFF", fontWeight: "bold"}}>Day</span> - Light blue (#27B4FFFF)</li>
                                            <li className={"mb-1"}><span style={{color: "#276BFFFF", fontWeight: "bold"}}>Evening</span> - Blue (#276BFFFF)</li>
                                            <li className={"mb-1"}><span style={{color: "#0B16FFFF", fontWeight: "bold"}}>Night</span> - Dark blue (#0B16FFFF)</li>
                                        </ul>
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Hour Display:</strong> Hours are displayed in 12-hour format (e.g., "12:00 AM", "1:00 PM") for easy reading.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-edit me-2 text-primary"}></i>Editing Shift Assignments
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        Click on any hour's dropdown to change its shift assignment.
                                    </li>
                                    <li className={"mb-2"}>
                                        Select from the three available options: <strong>Day</strong>, <strong>Evening</strong>, or <strong>Night</strong>.
                                    </li>
                                    <li className={"mb-2"}>
                                        The dropdown will immediately update its color to match the selected shift.
                                    </li>
                                    <li className={"mb-2"}>
                                        Changes are saved locally until you click "Save Changes".
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-save me-2 text-primary"}></i>Saving Changes
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        The <strong>"Save Changes"</strong> button only appears when you have made modifications to the shift assignments.
                                    </li>
                                    <li className={"mb-2"}>
                                        Click <strong>"Save Changes"</strong> to permanently save your configuration to the database.
                                    </li>
                                    <li className={"mb-2"}>
                                        After saving, the button will disappear until you make additional changes.
                                    </li>
                                    <li className={"mb-2"}>
                                        A success message will confirm when your changes have been saved.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-rotate-ccw me-2 text-primary"}></i>Resetting Changes
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        The <strong>"Reset"</strong> button appears next to "Save Changes" when you have unsaved modifications.
                                    </li>
                                    <li className={"mb-2"}>
                                        Click <strong>"Reset"</strong> to discard all unsaved changes and restore the original shift assignments.
                                    </li>
                                    <li className={"mb-2"}>
                                        This is useful if you want to start over without saving your changes.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-plus me-2 text-primary"}></i>Initial Setup
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        If no shift configuration exists for your campus, you will see a <strong>"Setup Shifts"</strong> button.
                                    </li>
                                    <li className={"mb-2"}>
                                        Click this button to create the initial shift configuration with all hours defaulting to "Day" shift.
                                    </li>
                                    <li className={"mb-2"}>
                                        After initial setup, you can then customize the shift assignments as needed.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-3"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-settings me-2 text-primary"}></i>Additional Tips
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        Shift assignments are campus-specific. Use the campus dropdown in the header to switch between campuses.
                                    </li>
                                    <li className={"mb-2"}>
                                        The configuration automatically refreshes every 10 minutes to show the latest data.
                                    </li>
                                    <li className={"mb-2"}>
                                        All 24 hours must be assigned to a shift - there are no unassigned hours.
                                    </li>
                                    <li className={"mb-2"}>
                                        Changes take effect immediately after saving and will be used in all shift-based operations throughout the system.
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className={"modal-footer"}>
                            <button type={"button"} className={"btn btn-secondary"} data-bs-dismiss={"modal"}>Close</button>
                        </div>
                    </div>
                </div>
            </div>
            <Suspense fallback={"Loading..."}>
                <ToastContainer position={"bottom-right"} theme={"colored"} newestOnTop={true} pauseOnHover={true}
                                autoClose={10000} closeOnClick={true}/>
            </Suspense>
        </>
    );
};

export default Shifts;